export const DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss";

export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const DAYS_PER_MONTH = 30;
export const MONTHS_PER_YEAR = 12;
export const DAYS_PER_YEAR = 365;

export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR;
export const SECONDS_PER_DAY = SECONDS_PER_HOUR * HOURS_PER_DAY;
export const SECONDS_PER_YEAR = SECONDS_PER_DAY * DAYS_PER_YEAR;

export const MILLISECONDS_PER_DAY = SECONDS_PER_DAY * 1000;

// Rounding thresholds - when to round up to the next unit
export const ROUNDING_THRESHOLDS = {
  MINUTES_TO_HOUR: MINUTES_PER_HOUR / 2, // 30+ minutes rounds to next hour
  HOURS_TO_DAY: HOURS_PER_DAY / 2, // 12+ hours rounds to next day
  DAYS_TO_MONTH: DAYS_PER_MONTH / 2, // 15+ days rounds to next month (consistent with useReadableTimeWindow)
} as const;
